import { FaCashRegister } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import EmptyTable from './Table/EmptyTable';
import FilterTable, { BaseData } from './Table/Table';
import { EventCashRegisterSessionDTO, EventCashRegisterDTO } from '../models/event';
import { parseFriendlyDateAndHour } from '../utils/dates';
import UserDTO from '../models/user';
import LoadingLottie from './atoms/LoadingLottie';
import { BusinessCashRegisterDTO } from '../models/business';

interface TableRow extends BaseData {
  name: string;
  status: JSX.Element;
  opened_at: string;
  closed_at: string;
  users: string;
  event_cash_register_id: string;
}

interface SessionsTableProps {
  businessCashRegisters?: BusinessCashRegisterDTO[];
  eventCashRegisters?: EventCashRegisterDTO[];
  isLoadingEventCashRegisters?: boolean;
}

const SessionsTable = ({ eventCashRegisters, isLoadingEventCashRegisters, businessCashRegisters }: SessionsTableProps) => {
  const navigate = useNavigate();

  const parsedData = () => {
    const allSessions: { cash_register_session: EventCashRegisterSessionDTO, event_cash_register: EventCashRegisterDTO, business_cash_register: BusinessCashRegisterDTO | null, user: UserDTO }[] = [];
    for (const cashRegister of eventCashRegisters || []) {
      for (const session of cashRegister.cash_register_sessions || []) {
        allSessions.push({
          user: session.user,
          cash_register_session: session,
          event_cash_register: cashRegister,
          business_cash_register: businessCashRegisters?.find((businessCashRegister) => businessCashRegister.id === cashRegister.cash_register_id) || null,
        });
      }
    }
    return allSessions.sort((a, b) => new Date(a.cash_register_session.closed_at).getTime() - new Date(b.cash_register_session.closed_at).getTime());
  };

  const rows: TableRow[] = parsedData().map((session, index) => ({
    id: session.cash_register_session.id,
    event_cash_register_id: session.event_cash_register.id,
    name: session.business_cash_register?.name || `Caja ${index + 1}`,
    status: session.cash_register_session.closed_at ? (
      <div className='tag-warning'>
        Cerrada
      </div>
    ) : (
      <div className='tag-primary'>
        Abierta
      </div>
    ),
    opened_at: parseFriendlyDateAndHour(session.cash_register_session.opened_at, true),
    closed_at: session.cash_register_session.closed_at ? parseFriendlyDateAndHour(session.cash_register_session.closed_at, true) : '',
    users: session.user?.username || 'Sin usuario',
  })) || [];

  const headCells = [
    { id: 'status', label: 'Estado' },
    { id: 'name', label: 'Nombre' },
    { id: 'opened_at', label: 'Fecha de apertura' },
    { id: 'closed_at', label: 'Fecha de cierre' },
    { id: 'users', label: 'Usuario' },
  ];

  const actions = (row: TableRow) => (
    <div className='flex gap-2'>
      <div onClick={() => navigate(`${row.event_cash_register_id}/${row.id}`)} className="cursor-pointer text-primary-500 hover:underline">Ver</div>
    </div>
  );

  if (isLoadingEventCashRegisters) {
    return (
      <div>
        <LoadingLottie />
      </div>
    );
  }

  return (
    <div>
      {rows.length > 0 ? (
        <FilterTable
          rows={rows || []}
          headCells={headCells}
          tableId="sessions-table"
          actions={actions}
          pagination={{ enabled: true, pageSize: 10 }}
        />
      ) : (
        <EmptyTable
          title="No hay sesiones"
          info="Actualmente no hay cajas registradoras abiertas o ninguna sesión iniciada."
          icon={FaCashRegister}
          iconColor="text-primary-500"
        />
      )}
    </div>
  );
};

export default SessionsTable;
